import type { QuantityProps } from "@components/ngg";
import { Quantity } from "@components/ngg";
import { MinusIcon, PlusIcon } from "@ngg/icons";
import type { CartItem } from "@server/gql/graphql";

import { cn } from "@/lib/utils";

import { isCheckoutDisabled } from "../Stock/Stock.utils";

export default function Action({
  item,
  update,
  prefix,
  loading,
  className,
  classNames,
}: {
  item: CartItem;
  update: (item: CartItem) => void;
  prefix?: string;
  loading?: boolean;
  className?: string;
  classNames?: QuantityProps["classNames"];
}) {
  return (
    <div className={cn("flex items-center @2xl:justify-self-end", className)}>
      {prefix && <span className="mr-2 text-sm uppercase">{prefix}:</span>}
      <Quantity
        dense
        readOnly
        disabled={loading}
        value={item.quantity}
        onIncrease={() =>
          isCheckoutDisabled(item)
            ? null
            : update({
                ...item,
                quantity: item.quantity + 1,
              })
        }
        onDecrease={() =>
          update({
            ...item,
            quantity: item.quantity - 1,
          })
        }
        DecreaseIcon={<MinusIcon />}
        IncreaseIcon={<PlusIcon />}
        className="border-grey-200"
        classNames={{
          decreaseButton: cn(
            "flex basis-1/3 items-center justify-center text-sm",
            classNames?.decreaseButton,
          ),
          increaseButton: cn(
            "flex basis-1/3 items-center justify-center text-sm",
            classNames?.increaseButton,
            isCheckoutDisabled(item) && "cursor-not-allowed opacity-50",
          ),
          wrapper: cn(
            "border-x-1 h-5 max-w-16 divide-x border-grey-150 text-sm child:border-grey-150 @2xl:h-8 @2xl:max-w-24",
            classNames?.wrapper,
          ),
          input: cn("basis-1/3 text-sm", classNames?.input),
        }}
      />
    </div>
  );
}
